import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { TravelRequestCreate } from '@/module/Travel/Request/TravelRequestCreate';

import { NoContentPlaceholder } from '@/core/components';

import { RoleType, useCurrentUser } from '@feature/security';

export const Route = createFileRoute('/_auth/travel/_travel/requests/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  const { t } = useTranslation();
  const { currentRole } = useCurrentUser();

  if (currentRole !== RoleType.AUTHOR) {
    return <NoContentPlaceholder title={t('travel.requests.noAccess')} />;
  }

  return <TravelRequestCreate />;
}
